import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const AGENT_SEO_OVERRIDES_PATH = "/api/agent/seo-overrides";

function agentSeoOverridesUrl() {
  return resolveApiUrl(AGENT_SEO_OVERRIDES_PATH);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_seo_overrides_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 20000,
    sid,
  };
}

export async function fetchAgentSeoOverrides(pathname) {
  const cfg = await withSessionRequestConfig();
  const params = {};
  if (pathname && String(pathname).trim()) {
    params.pathname = String(pathname).trim();
  }
  const { data } = await axios.get(agentSeoOverridesUrl(), {
    ...cfg,
    params,
  });
  if (Array.isArray(data?.overrides)) {
    return data.overrides;
  }
  if (data && Object.prototype.hasOwnProperty.call(data, "override")) {
    return data.override ? [data.override] : [];
  }
  return [];
}

export async function saveAgentSeoOverride(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.put(
    agentSeoOverridesUrl(),
    {
      pathname: payload?.pathname,
      index_enabled: payload?.index_enabled,
      follow_enabled: payload?.follow_enabled,
      title: payload?.title,
      description: payload?.description,
      canonical_url: payload?.canonical_url,
      sessionID: cfg.sid,
    },
    cfg
  );
  return data?.override || null;
}
